import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { loginOpenId, openId, signupOpenId } from './types';
import {
  requestLoginOpenIdSuccess,
  requestLoginOpenIdFailure,
  requestOpenIdSuccess,
  requestOpenIdFailure,
  requestSignupOpenIdSuccess,
  requestSignupOpenIdFailure,
} from './actions';

const logger = new Logger('Saga:SignupOpenId');

export function* requestOpenIdSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.get_partner', {
        tokenId: action.token,
      }),
    );

    yield put(requestOpenIdSuccess(response.data));
  } catch (error) {
    logger.error('Failed to get partner:', error);
    yield put(requestOpenIdFailure(error));
  }
}

export function* requestSignupOpenIdSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');
  const { hash, ...values } = action.payload;

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.platform.auth_signup', { hash }),
      values,
    );

    window.location.href = response.data.url;
    yield put(requestSignupOpenIdSuccess());
  } catch (error) {
    logger.error('Failed to signup from openId:', error);
    yield put(requestSignupOpenIdFailure(error.response));
  }
}

export function* requestLoginOpenIdSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');
  const { hash, ...values } = action.payload;

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.platform.auth_signin', { hash }),
      values,
    );

    window.location.href = response.data.url;
    yield put(requestLoginOpenIdSuccess());
  } catch (error) {
    logger.error('Failed to login from openId:', error);
    yield put(requestLoginOpenIdFailure(error.response));
  }
}

export default function* marketplaceSaga() {
  return yield all([
    takeLatest(openId.request, requestOpenIdSaga),
    takeLatest(signupOpenId.request, requestSignupOpenIdSaga),
    takeLatest(loginOpenId.request, requestLoginOpenIdSaga),
  ]);
}
